import styled from "styled-components";



import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { logoutHandler } from 'src/consumer/services/loginLogoutHandlers';
import { LocalizationContext } from "src/consumer/context/LocalizationContext";
import { useContext } from "react";



export const NavbarParent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-top: 16px;
    position: absolute;
    z-index: 2;
    top: 0;
`

export const CenterImage = styled.img`
    height: 40px;
    width: 40px;
    border-radius: 6px;
    cursor: pointer;
    filter: drop-shadow(7px 7px 30px rgba(0, 0, 0, 0.09));
    @media(min-width: 768px) {
        height: 45px;
        width: 45px;
    }
`

export const BackButton = styled.button`
    position: absolute;
    left: 20px;
    margin: 16px 20px;
    font-family: Outfit;
    font-weight: 400;
    font-size: 20px;
    color: #000;
    line-height: 1.5;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const SelectContainer = styled.div`
    display: none;
    position: absolute;
    right: 0;
    margin-right: 49px;
    @media(min-width: 768px) {
        display: flex;
        margin-right: 129px;
    }
`

export const LanguageSelectStylesForm = {
    control: (defaultStyles, state) => ({
        ...defaultStyles,
        backgroundColor: "#ffffff4D",
        border: "none",
        borderRadius: '36px',
        height: '36px',
        boxShadow: 'none',
        cursor: 'pointer'
    }),

    menuList: (defaultStyles, state) => {
        return {
            ...defaultStyles,
            "::-webkit-scrollbar": {
                display: 'none'
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            margin: 'auto',
            height: 'auto',
            maxHeight: 'none',
        }
    },

    option: (defaultStyles, state) => {
        return {
            ...defaultStyles,
            color: state.isSelected ? "#4C1487" : "#4C1487",
            backgroundColor: state.isSelected ? '#fff' : '#fff',
            fontSize: state.isSelected ? '17px' : '16px',
            fontWeight: state.isSelected ? '700' : '400',
            textAlign: 'center',
            ":hover": {
                fontWeight: '600'
            },
        }
    },

    menu: (defaultStyles, state) => ({
        ...defaultStyles,
        backgroundColor: '#fff',
        borderRadius: '11px',
        overflow: 'hidden',
        width: '150px',
    }),

    singleValue: (defaultStyles, state) => ({
        ...defaultStyles,
        color: '#000',
        fontWeight: '400',
        fontSize: '18px'
    }),
}

export const DropdownContainer = styled.div`
    position: absolute;
    right: 0;
    margin-right: 29px;
`

const ITEM_HEIGHT = 48;
export default function NavDropdown(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const navigate = useNavigate();
    const { localizedData } = useContext(LocalizationContext)
    const localizedStrings = localizedData?.strings?.onboardingFlow

    return (
        <div>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                    },
                }}
            >

                <MenuItem onClick={() => {
                    logoutHandler();
                    if (window.location.pathname === '/') {
                        window.location.reload();
                    } else {
                        navigate('/', {});
                    }
                }}>
                    {localizedStrings?.logout || 'Logout'}
                </MenuItem>
            </Menu>
        </div>
    );
}